const $acItem = $('.accordion-item'),
		$acHeader = $('.accordion-item__header');

$acHeader.click(function(){
	let currentItem = $(this).parent($('.accordion-item'));
	
	currentItem.hasClass('open') ? currentItem.removeClass('open') : currentItem.addClass('open');
});


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/accordion.js